import React from "react";

const CalendarToolbar = ({
    filters,
    employees = [],
    onSearchChange,
    onEmployeeChange,
    onDepartmentChange,
    onStatusChange,
    onReset,
    taskCount,
    totalCount,
    loading,
    refreshing,
    onRefresh,
}) => {
    return (
        <div
            style={{
                display: "flex",
                gap: "12px",
                marginBottom: "20px",
                flexWrap: "wrap",
                alignItems: "center",
            }}
        >
            <input
                placeholder="Search tasks..."
                value={filters.search}
                onChange = { (event) => onSearchChange(event.target.value) }
                disabled={loading}
                style={{
                    flex: 1,
                    minWidth: "250px",
                    padding: "10px 14px",
                    border: "1px solid #d1d5db",
                    borderRadius: "10px",
                }}
            />

            <select
                value={filters.employee}
                onChange = { (event) => onEmployeeChange(event.target.value) }
            >
                <option value="">Employee</option>

                {employees.map((employee) => (
                    <option
                        key={employee}
                        value={employee}
                    >
                        {employee}
                    </option>
                ))}
            </select>

            <select
                value={filters.status}
                onChange = { (event) => onStatusChange(event.target.value) }
            >
                <option value="">Status</option>
                <option value="pending">Pending</option>
                <option value="in_progress">In Progress</option>
                <option value="paused">Paused</option>
                <option value="review">Review</option>
                <option value="completed">Completed</option>
                <option value="cancelled">Cancelled</option>
            </select>

            <button
                type="button"
                onClick={onReset}
                style={{
                    padding: "10px 14px",
                    border: "1px solid #d1d5db",
                    borderRadius: "10px",
                    background: "#fff",
                    cursor: "pointer",
                }}
            >
                Reset
            </button>

            <button
                type="button"
                onClick={onRefresh}
                disabled={loading || refreshing}
                style={{
                    padding: "10px 14px",
                    border: "1px solid #d1d5db",
                    borderRadius: "10px",
                    background: "#fff",
                    cursor: "pointer",
                }}
            >
                {refreshing ? "Refreshing..." : "Refresh"}
            </button>

            <span
                style={{
                    color: "#64748b",
                    fontSize: "14px",
                }}
            >
                Showing <strong>{taskCount}</strong> of{" "}
                <strong>{totalCount}</strong>
            </span>
        </div>
    );
};

export default CalendarToolbar;
